<template>
  <v-card :href="resourceHref(value)" class="fill-height" rounded="0">
    <div v-if="value.item">
      <ImageCover
        v-if="isArticle(value)"
        :aspect-ratio="aspectRatio"
        :value="value.item"
        default-key="article_default_image"
      />

      <ImageCover
        v-else-if="isCaseStudy(value)"
        :aspect-ratio="aspectRatio"
        :value="value.item"
        default-key="download_default_image"
      />

      <ImageCover
        v-else-if="isDownload(value)"
        :aspect-ratio="aspectRatio"
        :value="value.item"
        default-key="download_default_image"
      />

      <ImageCover
        v-else-if="isFaq(value)"
        :aspect-ratio="aspectRatio"
        :value="value.item"
      />

      <VideoCover
        v-else-if="isVideo(value)"
        :aspect-ratio="aspectRatio"
        :gradient="RESOURCES_VIDEO_GRADIENT"
        :value="value.item"
        content-class="d-flex align-center justify-center"
      >
        <v-icon :icon="mdiPlayCircleOutline" color="white" size="50" />
      </VideoCover>
    </div>

    <v-card-item v-if="value.item.title">
      <h5 class="text-subtitle-1 font-weight-bold">{{ value.item.title }}</h5>
    </v-card-item>

    <v-card-text
      v-if="value.item.summary"
      class="text-body-1"
      style="line-height: 150%"
    >
      {{ value.item.summary }}
    </v-card-text>
  </v-card>
</template>

<script setup>
import { RESOURCES_VIDEO_GRADIENT } from '#root/lib/consts'
import {
  isArticle,
  isCaseStudy,
  isDownload,
  isFaq,
  isVideo,
  resourceHref
} from '#root/lib/utils'
import { mdiPlayCircleOutline } from '@mdi/js'

defineProps({
  value: {
    required: true,
    type: Object
  }
})

const aspectRatio = 16 / 7
</script>
